import { useHostNavigate } from '../hostNavigation/HostNavigationContext'

/**
 * Navigate to a URL in this or another Buffer app. Same-origin targets use the
 * host app's router when it provides one (Publish); otherwise the navigation
 * is a full-page load.
 *
 * @example
 * ```tsx
 * const navigateCrossApp = useCrossAppNavigate()
 * navigateCrossApp('https://publish.buffer.com')
 * ```
 */
export function useCrossAppNavigate(): (href: string) => void {
  return useHostNavigate()
}
